module.exports = __webpack_public_path__ + "img/dsci0119.ff4d2026.jpg";